/**
 * Created by tofael on 7/27/18.
 */
import React from 'react';

import Toolbar from './toolbar/';
import LineChart from './line-chart';
import PieChart from './pie-chart';

const styles = {
  root: {

  },
  row: {
    margin: '10px 10px 20px 0px'
  },
  rowInfoBox: {
    margin: '10px 20px 20px 10px'
  }
};

const Stats = ({missions, calls, totalMissions, totalCalls, missionSources, callResults, missionSourcesTotal, callResultsTotal, onDateRangeChange}) => (
  <div >
    <Toolbar onDateRangeChange={onDateRangeChange}/>
    <div className="row" style={styles.row}>
      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-md m-b-15">
        <LineChart
          title={`Missions(${totalMissions})`}
          data={missions}
          dataKey="missions"
        />
      </div>

      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-md m-b-15">
        <LineChart
          title={`Calls(${totalCalls})`}
          data={calls}
          dataKey="calls"
        />
      </div>
    </div>

    <div className="row" style={styles.row}>
      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-md m-b-15">
        <PieChart
          title={`Mission Sources(${missionSourcesTotal})`}
          data={missionSources}
          dataKey="missions"
        />
      </div>

      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-md m-b-15">
        <PieChart
          title={`Call Results(${callResultsTotal})`}
          data={callResults}
          dataKey="calls"
        />
      </div>
    </div>
  </div>
);

export default Stats;


// WEBPACK FOOTER //
// ./src/screens/stats/index.js